"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@dynamynd/core");

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var FullWidthImage = styled_components_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n"], ["\n    width: 100%;\n"])));
var OverallScoreImage = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      width = _a.width,
      source = _a.source,
      rest = __rest(_a, ["activeBreakpoint", "width", "source"]);

  return react_1.default.createElement("div", __assign({}, rest), react_1.default.createElement(FullWidthImage, {
    src: source.uri
  }));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    max-width: 428px;\n    max-height: 498px;\n    margin: auto;\n    padding: 15px;\n    border-radius: 6px;\n    background-color: #ffffff;\n"], ["\n    ", "\n    max-width: 428px;\n    max-height: 498px;\n    margin: auto;\n    padding: 15px;\n    border-radius: 6px;\n    background-color: #ffffff;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      width = _a.width;
  return setOverallScoreImageDimensions(activeBreakpoint, width);
});

function setOverallScoreImageDimensions(activeBreakpoint, screenWidth) {
  if (responsive_1.isLarge(activeBreakpoint) || responsive_1.isExtraLarge(activeBreakpoint)) {
    return "\n            width: 428px;\n            height: 431px;\n        ";
  }

  var aspect = 1.17;
  var gutter = core_1.getActiveGutterSize(activeBreakpoint);
  var width = screenWidth - 6 * gutter;
  var height = width * aspect;
  return "\n        width: " + width + "px;\n        height: " + height + "px;\n    ";
}

exports.default = responsive_1.withResponsiveMeta(OverallScoreImage);
var templateObject_1, templateObject_2;